<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="800"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Form ref="Forms" :model="Forms" :rules="Rules" label-position="top">
                <Row :gutter="32">
                    <Divider orientation="left" class="text-primary">基本信息</Divider>
                    <Col span="24">
                        <FormItem label="采购标题" prop="title">
                            <Input v-model="Forms.title" clearable placeholder="采购标题" />
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="采购产品" prop="product">
                            <Select filterable clearable placeholder="采购产品" @on-change="selectProduct">
                                <Option v-for="(item,index) in productList" :key="index" :value="item.b_id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="24" v-if="Forms.product_price.length > 0">
                        <template v-for="(item, index) in Forms.product_price" :key="index">
                        <Row :gutter="16">
                            <Col span="10">
                                <FormItem :label="'—— 产品： '+item.name + ' 单价'" :prop="'product_price.' + index + '.price'" :rules="{required: true,type:'number' , message: '必填', trigger: 'blur', transform(value) { return parseFloat(value)}}">
                                    <Input v-model="item.price" type="number" class="width-100" clearable placeholder="0.00" />
                                </FormItem>
                            </Col>
                            <Col span="10">
                                <FormItem label="采购数量" :prop="'product_price.' + index + '.num'" :rules="{required: true, message: '必填', trigger: 'blur'}">
                                    <Input v-model="item.num" class="width-100" clearable placeholder="如:500kg" />
                                </FormItem>
                            </Col>
                            <Col span="4">
                                <FormItem label="操作">
                                    <a href="javascript:void(0);" @click="productDelete(index)" class="text-danger"><Icon type="md-trash" />删除</a>
                                </FormItem>
                            </Col>
                        </Row>
                        </template>
                    </Col>
                    <Col span="12">
                        <FormItem label="项目" prop="project_id">
                            <Select v-model="Forms.project_id" clearable filterable  placeholder="项目">
                                <Option v-for="(item,index) in projectList" :key="index" :value="item.project_id">{{item.name}} <small class="text-orange"> [ {{item.status_name}} ]</small></Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="供应商" prop="company_id">
                            <Select v-model="Forms.company_id" clearable filterable  placeholder="供应商">
                                <Option v-for="(item,index) in companyList" :key="index" :value="item.company_id">{{item.company}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="采购金额" prop="buyer_money">
                            <Input v-model="Forms.buyer_money" type="number" clearable placeholder="采购金额" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="合同金额" prop="pay_money">
                            <Input v-model="Forms.pay_money" type="number" clearable placeholder="合同金额" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="合同凭证" prop="contract">
                            <Input v-model="Forms.contract" disabled>
                                <template #append>
                                    <div class="f-center">
                                        <Upload
                                            :show-upload-list="false"
                                            :action="upload_url"
                                            :headers = "{'token': $store.state.token}"
                                            :format="['xls','xlsx','rar','zip','doc','docx','txt','docx','jpg','jpeg','png','pdf']"
                                            :max-size="50 * 1024"
                                            :on-success="handleSuccess"
                                            :on-format-error="handleFormatError"
                                            :on-exceeded-size="handleMaxSize">
                                            <a href="javascript:void(0);" class="text-primary"><Icon type="md-cloud-upload" />上传</a>
                                        </Upload>
                                        <Divider type="vertical" />
                                        <a href="javascript:void(0);" @click="FileDelete()" class="text-danger"><Icon type="md-trash" />删除</a>
                                        <Divider type="vertical" />
                                        <a href="javascript:void(0);" @click="FileDownload(Forms.contract)" class="text-violet"><Icon type="md-download" />下载</a>
                                    </div>
                                </template>
                            </Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="负责人" prop="head_id">
                            <Select v-model="Forms.head_id" clearable filterable  placeholder="负责人">
                                <Option v-for="(item,index) in userList" :key="index" :value="item.admin_id">{{item.real_name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="采购描述" prop="buyer_desc">
                            <Input v-model="Forms.buyer_desc" type="textarea" :rows="8" clearable placeholder="采购描述" />
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="备注信息" prop="remark">
                            <Input v-model="Forms.remark" type="textarea" :rows="4" clearable placeholder="仅内部可见" />
                        </FormItem>
                    </Col>
                    <Divider orientation="left" class="text-primary">收款账户</Divider>
                    <Col span="12">
                        <FormItem label="收款账户" prop="bank_account">
                            <Input v-model="Forms.bank_account" class="width-70" clearable placeholder="" />
                            &nbsp;<Button type="primary" class="width-27" ghost  @click="getAccount()">自动获取</Button>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="账户实名" prop="bank_real_name">
                            <Input v-model="Forms.bank_real_name" clearable placeholder="" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="开户银行" prop="bank_name">
                            <Input v-model="Forms.bank_name" clearable placeholder="" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="开户地址" prop="bank_address">
                            <Input v-model="Forms.bank_address" clearable placeholder="" />
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <div class="box-drawer-footer">
                <Button class="mr10" @click="FormReset()">取消</Button>
                <Button type="primary" :loading="$store.state.loading" @click="FormSubmit()">保存</Button>
            </div>
        </div>

    </Drawer>
</template>

<script>

import {getBuyerConfig, getBuyerDetail, saveBuyer} from "@/apis/buyer";
import {getCompanyAccount} from "@/apis/company";

export default {
    name: 'CompanyCreate',
    components: {
    },
    emits: ['trueHandler'],
    data () {
        return {
            title : '新增采购',
            isBox : false,
            projectList: [],
            companyList: [],
            productList: [],
            userList: [],

            upload_url : this.$uploadFileApi,
            site_url : this.$siteApi,

            Forms : {
                buyer_id: '',
                title: '',
                project_id: '',
                company_id: '',
                product: [],
                product_price: [],
                buyer_money: '',
                pay_money: '',
                contract: '',
                head_id: '',
                buyer_desc: '',
                remark: '',
                bank_account: '',
                bank_real_name: '',
                bank_name: '',
                bank_address: ''
            },
            Rules : {
                title: [
                    { required: true, type: 'string',  message: '请输入采购标题', trigger: 'blur' }
                ],
                product: [
                    { required: true, type: 'array',  message: '请选择采购产品', trigger: 'change'}
                ],
                project_id: [
                    { required: true, type: 'number',  message: '请选择项目', trigger: 'change',  transform(value) { return parseInt(value)}  }
                ],
                company_id: [
                    { required: true, type: 'number',  message: '请选择供应商', trigger: 'change',  transform(value) { return parseInt(value)}  }
                ],
                buyer_money: [
                    { required: true, type: 'number',  message: '请输入采购金额', trigger: 'blur',  transform(value) { return parseFloat(value)} }
                ],
                pay_money: [
                    { required: true, type: 'number',  message: '请输入合同金额', trigger: 'blur',  transform(value) { return parseFloat(value)} }
                ],
                head_id: [
                    { required: true, type: 'number',  message: '请选择负责人', trigger: 'change',  transform(value) { return parseInt(value)}  }
                ],
                buyer_desc: [
                    { required: true, type: 'string',  message: '请输入采购描述', trigger: 'blur' }
                ]
            }
        }
    },
    methods: {
        productDelete(index){
            let that = this;
            that.Forms.product.forEach((item,idx)=>{
                if(parseInt(item) === parseInt(that.Forms.product_price[index].b_id)){
                    that.Forms.product.splice(idx , 1);
                    that.Forms.product_price.splice(index , 1);
                }
            })
        },
        selectProduct(e){
            let that = this;
            if(!that.Forms.product.includes(e)){
                that.productList.forEach((item)=>{
                    if(parseInt(item.b_id) === parseInt(e)){
                        that.Forms.product.push(e);
                        that.Forms.product_price.push({
                            b_id:item.b_id,
                            name:item.name,
                            num:'',
                            price:''
                        });
                    }
                })
            }
        },
        /**
         功能：
         time: 2026/1/5 15:10
         **/
        getAccount(){
            let that = this;
            if(!that.Forms.company_id){
                that.$Message.error({ background: true,duration:3, content: '请选择供应商'});
                return;
            }
            getCompanyAccount(that.Forms.company_id).then(e => {
                let data = e.data;
                that.Forms.bank_account = data.bank_account ?? '';
                that.Forms.bank_real_name = data.bank_real_name ?? '';
                that.Forms.bank_name = data.bank_name ?? '';
                that.Forms.bank_address = data.bank_address ?? '';
            })
        },
        /**
         功能：图片文件
         time: 2025/12/17 10:48
         **/
        FileDelete(){
            let that = this;
            that.Forms.contract = "";
        },
        /**
         功能：
         time: 2025/12/17 10:48
         **/
        handleSuccess(res){
            let that = this;
            if(res.code == 100){
                this.Forms.contract = res.data.url;
            }else{
                that.$Message.error({ background: true,duration:3, content: res.msg});
            }
        },
        /**
         功能：
         time: 2025/12/17 10:48
         **/
        handleFormatError(){
            let that = this;
            that.$Message.error({ background: true,duration:3, content: '只支持 PDF | xls | xlsx | rar | zip | doc | docx | txt | jpg | jpeg | png 文件 ' });
            return false;
        },
        /**
         功能：
         time: 2025/12/17 10:48
         **/
        handleMaxSize(){
            let that = this;
            that.$Message.error({ background: true,duration:3, content: '文件大小不能超出 50M' });
            return false;
        },
        /**
         功能：
         time: 2025/12/19 18:12
         **/
        FileDownload(url){
            let that = this;
            if(url){
                //下载文件
                const fileUrl = that.site_url + url; // 文件的URL地址
                const parts = fileUrl.split('/');
                const fileName = parts[parts.length - 1];
                const link = document.createElement('a');
                link.href = fileUrl;
                link.target = '_blank';
                link.setAttribute('download', fileName);
                link.click();
            }else{
                that.$Message.error({ background: true,duration:3, content: '没有资料可下载'});
            }
        },
        /**
         功能：
         time: 2026/1/5 14:49
         **/
        GetConfig(){
            let that = this;
            getBuyerConfig().then(e=>{
                that.projectList = e.data.projectList ?? [];
                that.companyList = e.data.companyList ?? [];
                that.productList = e.data.productList ?? [];
                that.userList = e.data.userList ?? [];
            })
        },
        /**
         功能：
         time: 2025/12/17 16:04
         **/
        GetDetail(buyer_id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getBuyerDetail(buyer_id).then(e => {
                let data = e.data;
                for (let v of Object.keys(that.Forms)) {
                    that.Forms[v] = data[v];
                    if(v === 'project_id' || v === 'company_id' || v === 'head_id') {
                        that.Forms[v] = parseInt(data[v]);
                    }else if(v === 'product' ) {
                        that.Forms[v] = data[v] ? data[v] : [];
                    }else if(v === 'product_price' ) {
                        that.Forms[v] = data.proList ? data.proList : [];
                    }else{
                        that.Forms[v] = data[v];
                    }
                }
            })
        },
        /**
         功能：
         time: 2025/12/17 10:47
         **/
        add(){
            this.isBox = true;
            this.GetConfig();
        },
        /**
         功能：
         time: 2025/12/17 10:47
         **/
        edit(buyer_id){
            this.isBox = true;
            this.title = '编辑采购信息';
            this.GetConfig();
            if(buyer_id) this.GetDetail(buyer_id);
        },
        /**
         功能：
         time: 2025/12/17 10:47
         **/
        FormSubmit(){
            let that = this;
            this.$refs['Forms'].validate((valid) => {
                if (valid) {
                    that.$store.commit('SET_LOADING' , true);
                    saveBuyer(that.Forms).then( e =>{
                        that.$Message.success({ background: true,duration:3, content: e.msg });
                        that.FormReset();
                        that.$emit('trueHandler');
                    })
                }
            })
        },
        /**
         功能：
         time: 2025/12/17 10:47
         **/
        FormReset(){
            this.isBox = false;
            this.title = '新增采购';
            this.$refs['Forms'].resetFields();
            this.Forms.projectList = [];
            this.Forms.companyList = [];
            this.Forms.productList = [];
            this.Forms.userList = [];
            this.Forms.buyer_id = '';
            this.Forms.product = [];
            this.Forms.contract = '';
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
.forms {
    .ivu-form-item {
        //margin-bottom: 0 !important;
    }
}
.spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
}
.spin-text {
    font-size: 12px;
    padding-top: 10px;
}
</style>
